import { Button } from "@/components/ui/button";
import { CheckCircle2, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import heroImage from "@/assets/masonry-pro-hero-2.webp";
import { CallOrTextButton } from "@/components/CallOrTextButton";
import { HeroContactCard } from "@/components/HeroContactCard";

const trustBadges = [
  "35+ Years Experience",
  "5-Star Google Rating",
  "Licensed & Insured",
];

export function HeroSection() {
  const scrollToServices = () => {
    const element = document.getElementById("services");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      style={{
        backgroundColor: '#0d1017',
        position: 'relative',
        overflow: 'hidden',
        paddingTop: '140px',
        paddingBottom: '40px',
      }}
    >
      {/* Hero background image as <img> for LCP optimization */}
      <img
        src={heroImage}
        alt="Newly installed patio pavers with outdoor dining and seating in Paramus, Bergen County, NJ, by Masonry Pro Construction"
        width={1920}
        height={1080}
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Gradient overlay */}
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(180deg, rgba(13,16,23,0.45) 0%, rgba(13,16,23,0.65) 100%)' }}
      />
      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="lg:grid lg:grid-cols-[1fr_minmax(360px,420px)] lg:gap-8 lg:items-start">
        <div className="max-w-3xl" style={{ padding: '2rem' }}>
          <h1 style={{ color: '#e1e7ef', fontSize: '3rem', fontWeight: 'bold', lineHeight: 1.1, marginBottom: '1rem', textShadow: '0 2px 8px rgba(0,0,0,0.9)' }}>
            <span style={{ color: '#e1e7ef', WebkitTextFillColor: '#e1e7ef', textShadow: '0 2px 8px rgba(0,0,0,0.9)' }}>Local</span>{" "}
            <span style={{ color: '#c4a24e', WebkitTextFillColor: '#c4a24e', textShadow: '0 2px 8px rgba(0,0,0,0.9)' }}>Masonry Contractor in Totowa, NJ</span>{" "}
            <span style={{ color: '#e1e7ef', WebkitTextFillColor: '#e1e7ef', textShadow: '0 2px 8px rgba(0,0,0,0.9)' }}>Serving North Jersey</span>
          </h1>
          
          <p style={{ color: '#c4a24e', WebkitTextFillColor: '#c4a24e', fontSize: '0.95rem', fontWeight: 500, letterSpacing: '0.025em', marginBottom: '1.5rem', textShadow: '0 1px 4px rgba(0,0,0,0.9)' }}>
            Paver Patios | Retaining Walls | Stone | Steps &amp; Stoops | Paving | Concrete | Waterproofing | Residential &amp; Commercial
          </p>
          
          <p style={{ color: 'rgba(225, 231, 239, 0.8)', fontSize: '1.25rem', marginBottom: '2rem', textShadow: '0 1px 4px rgba(0,0,0,0.9)' }}>
            Ready to finally build that patio you've been thinking about? Want a backyard you actually use instead of just look at? Is your retaining wall leaning like the Tower of Pisa?
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <Button variant="hero" size="xl" asChild className="h-auto min-h-14 py-3">
              <Link to="/contact" className="whitespace-normal text-center px-6 sm:px-10 leading-tight">Schedule Your Free Assessment</Link>
            </Button>
            <CallOrTextButton />
          </div>
          {/* Trust badges */}
          <div className="glass-card rounded-xl p-4 mb-6 max-w-2xl">
            <div className="flex flex-wrap gap-x-6 gap-y-3">
              {trustBadges.map((badge) => (
                <div key={badge} className="flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 text-secondary" />
                  <span style={{ color: '#e1e7ef', fontWeight: 500 }}>{badge}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:hidden mb-6">
            <HeroContactCard />
          </div>
        </div>
          <div className="hidden lg:block pt-2">
            <HeroContactCard />
          </div>
        </div>

      </div>

      <div style={{ textAlign: 'center', marginTop: '2rem', position: 'relative', zIndex: 10 }}>
        <button
          onClick={scrollToServices}
          className="text-secondary hover:text-secondary/80 transition-colors animate-bounce"
          aria-label="Scroll down to services"
        >
          <ChevronDown className="h-10 w-10" />
        </button>
      </div>
    </section>
  );
}
